export const detroyUserSession = (store) => {
  return store.request('sessions', 'DELETE');
};

export const createUserSession = (store, loginData) => {
  return store.request('sessions', 'POST', loginData, { include: 'user' });
};
